<template>
  <div class="common-map-select">
    <div class="search-wrap">
      <i class="iconfont">&#xe6cb;</i>
      <GmapAutocomplete
          ref="autocomplete"
          :options="this.autocompleteOptions"
          :value="keyword"
          @place_changed="setPlace">
      </GmapAutocomplete>
    </div>

    <div class="result-list">
      <div>
        <span class="notice">{{ $t('address.current_address') }}
          <span v-show="isEnabledLocationService" class="reset" @click="relocate"><i class="iconfont">&#xe6d3;</i>{{ $t('map.relocate') }}</span>
        </span>
        <div v-if="isEnabledLocationService" class="result-item" @click="setPosition(location.lat, location.lng, location.address)">
          {{ currnetLocationAddress }}
        </div>
        <div v-else class="item-container result-item">
          <span class='item'>{{ $t('address.enable_location_service') }}</span>
          <mt-button class='item' size="small" type="primary" @click="relocate">開啟 <i class='iconfont icon-dingwei1'></i></mt-button>
        </div>
      </div>
      <div v-if="user" :class="{'nearby':style}">
        <span class="notice">{{ $t('address.store_address') }}</span>
        <div v-for="(item,index) in member_address_list" :key="index">
          <div class="result-address" @click="setPosition(item.address_latitude, item.address_longitude, item.address_detail)">
            {{ item.label || item.address_detail }}
          </div>
          <div class="result-info">{{ item.label ? item.address_detail : item.area_info }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { getAddressList, editAddress } from '../api/memberAddress'
import { gmapApi } from 'vue2-google-maps'
import { getPosition, geocode, transformAddress } from '@src/util/map'
import { Indicator, Toast } from 'mint-ui'
import { AddressState } from '@src/const/address'

export default {
  name: 'MapSelect',
  data () {
    return {
      AddressState,
      keyword: this.region,
      member_address_list: [],
      globalCode: 0,
      style: false,
      filterAddressTypes: [
        'administrative_area_level_1',
        'administrative_area_level_3',
        'route',
        'street_number'
      ],
      autocompleteOptions: {
        componentRestrictions: {
          country: 'tw'
        },
        fields: [
          'geometry',
          'formatted_address',
          'address_components',
          'plus_code'
        ]
      },
      location: {
        lat: 0,
        lng: 0,
        address_detail: undefined
      }
    }
  },
  props: {
    longitude: {},
    latitude: {},
    region: {
      type: String,
      default: ''
    },
    ifShowCurrent: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    google: gmapApi,
    longitude: function (newLongitude, oldLongitude) {
      if (newLongitude) {
        this.location = { lat: this.latitude, lng: this.longitude }
        this.initAddressList()
      }
    },
    region: function (val, old) {
      if (val !== old || old === '') {
        this.keyword = val + ' '
      }
    }
  },
  created () {
    this.initAddressList()
  },
  computed: {
    ...mapState({
      user: state => state.member.info,
      member_point: state => state.member.point,
      isEnabledLocationService: state => state.member.isEnabledLocationService
    }),
    currnetLocationAddress: function () {
      return this.location.address
    },
    google: gmapApi
  },
  methods: {
    ...mapMutations({
      memberPoint: 'memberPoint',
      setIsEnabledLocationService: 'setIsEnabledLocationService'
    }),
    geocode,
    transformAddress,
    getPosition,
    initAddressList () {
      if (!this.user) {
        return
      }

      getAddressList().then((res) => {
        this.member_address_list = res.result.address_list.map((item) => {
          item.address_latitude = parseFloat(item.address_latitude)
          item.address_longitude = parseFloat(item.address_longitude)
          return item
        })
        this.style = true
      }).catch((err) => {
        console.error(err)
      })
    },
    async getCurrentPosition () {
      try {
        const result = await this.geocode({ location: this.location })
        const formatted_address = this.transformAddress(result['address_components'])
        this.setLocation({address: formatted_address})
      } catch (err) {
        console.error(err)
      }
    },
    relocate () {
      /**
       * @todo Webview 請求定位權限
       */
      Indicator.open(this.$i18n.t('map.relocating'))
      getPosition((res) => {
        this.location = {
          lat: res.coords.latitude,
          lng: res.coords.longitude
        }
        this.setIsEnabledLocationService(true)
        this.getCurrentPosition()
        setTimeout(() => {
          Indicator.close()
        }, 500)
      }, (err) => {
        console.error(err)
        if (err.code === 1) {
          this.setIsEnabledLocationService(false)
        }
        Indicator.close()
      })
    },
    redirectCreateAddressForm() {
      this.$router.push({
        name: 'MemberAddressForm',
        query: {
          action: 'add',
          o2o_errand_type: AddressState.PICKUP_POINT,
          from: 'member_profile',
          set_member_point: true,
          address_detail: this.location.address_detail,
          address_latitude: this.location.address_latitude,
          address_longitude: this.location.address_longitude
        }
      })
    },
    setLocation(payload) {
      this.location = Object.assign({}, this.location, payload)
    },
    setPosition (lat, lng, name) {      
      this.$emit('setPosition', lat, lng, name)
    },
    setPlace (place) {
      this.keyword = this.transformAddress(place.address_components)
      this.setPosition(place.geometry.location.lat(), place.geometry.location.lng(), this.keyword)
    }
  }
}
</script>
<style>
.pac-item {
  padding: 10px;
  font-size: 10px;
  cursor: pointer;
}
</style>
<style lang="scss" scoped>

.common-map-select {
  background: #fff;
  position: absolute;
  width: 100%;
  height: 100%;

  .search-wrap {
    height: 2rem;
    line-height: 2rem;
    position: relative;
    position: absolute;
    left: .5rem;
    top: .5rem;
    right: 3.5rem;
    width: 90%;

    input {
      width: 100%;
      line-height: 2rem;
      text-indent: 2rem;
      font-size: 8px;
      display: block;
      background: #ebebeb;
      border: 0
    }

    i {
      position: absolute;
      left: 0;
      font-size: 1rem;
      line-height: 2rem;
      display: block;
      width: 2rem;
      text-align: center
    }

    .btn {
      position: absolute;
      right: -3rem;
      top: 50%;
      margin-top: -0.8rem
    }
  }

  .result-list {
    overflow-y: auto;
    position: absolute;
    top: 3rem;
    bottom: 0rem;
    width: 100%;

    .notice {
      display: block;
      padding: 1rem .5rem 0 .5rem;
      font-size: .7rem;
      color: #aeaeae;
      line-height: 1.5
    }

    .reset {
      float: right;
      color: orange
    }

    .current .notice, .nearby .notice {
      display: block
    }

    .result-item {
      padding: .7rem 0;
      font-size: .7rem;
      color: #1C1B20;
      margin: 0 0.5rem;
    }

    .result-address {
      padding: .7rem 0 .2rem 0;
      font-size: .8rem;
      color: #333;
      margin: 0 0.5rem;
      font-weight: bold;
    }

    .result-info {
      padding-bottom: .7rem;
      font-size: .7rem;
      color: #bbb;
      border-bottom: 1px solid #eee;
      margin: 0 0.5rem;
    }
  }

  .item-container {
    display: flex;
    justify-content: space-between;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
